import { render, staticRenderFns } from "./HourRegister.vue?vue&type=template&id=726cf034"
import script from "./HourRegister.vue?vue&type=script&lang=js"
export * from "./HourRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726cf034')) {
      api.createRecord('726cf034', component.options)
    } else {
      api.reload('726cf034', component.options)
    }
    module.hot.accept("./HourRegister.vue?vue&type=template&id=726cf034", function () {
      api.rerender('726cf034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/integration/HourRegister.vue"
export default component.exports